// Customer-Admin module access (frontend mirror of the backend gate).
//
// The backend (`/auth/users/me` -> `enabled_modules`) is authoritative and
// is enforced by `shared/module_access_middleware.py`. This helper only
// keeps the Customer Admin sidebar lock + route guard in sync. It applies
// ONLY to customer_admin / company_user - every other role (platform_admin,
// security_analyst, auditor, end_user) is returned "allowed" unchanged.
// It never widens access - an unknown module or a missing backend list
// falls back to "allowed" so nothing is regressed.

// Frontend module key (used by <ProtectedRoute moduleName=...> and the
// sidebar nav items) -> backend module keyword (config/menu_constants.py).
const MODULE_KEY_TO_KEYWORD = {
  "dashboard": "dashboard",
  "trust-center": "trust_center",
  "risk-assessment": "risk",
  "risk-management": "risk",
  "team-collaboration": "team_collaboration",
  "document-library": "document_library",
  "advanced-reporting": "ai_analytics",
  "reports": "ai_analytics",
  "incident-reporting": "incident_reporting",
  "security-dashboard": "security_dashboard",
  "settings": "settings",
  "asset-management": "asset_manager",
  "learning-management": "lms",
  "dspm": "dspm",
  "third-party-assessment": "tprm",
  "ai-vapt": "vapt",
  "ai-cspm": "cspm",
  "ai-virtual-soc": "virtual_soc",
};

// Only these roles are gated by module status; matches
// shared/module_access.py CUSTOMER_ADMIN_ROLES.
const CUSTOMER_ADMIN_ROLES = ["customer_admin", "company_user"];

export function isModuleEnabledForTenant(user, moduleKey) {
  if (!user || !user.role) return true;
  // Not a customer admin -> module status does not gate this role here.
  if (!CUSTOMER_ADMIN_ROLES.includes(user.role)) return true;

  const keyword = MODULE_KEY_TO_KEYWORD[moduleKey];
  // Not a status-controlled module (e.g. administration, ai-crm) -> leave
  // the existing role checks to decide.
  if (!keyword) return true;

  const enabled = Array.isArray(user.enabled_modules) ? user.enabled_modules : null;
  // Backend didn't send the list (older token / error) -> don't regress.
  if (!enabled || enabled.length === 0) return true;

  return enabled.includes(keyword);
}

export default isModuleEnabledForTenant;
